/** @jsx jsx */
import * as React from 'react';
import { jsx } from '@compiled/react';

import { css } from '@atlaskit/css';

export interface Props {
    name: string;
}

const DisableViewUntilMount: React.FC<React.PropsWithChildren<Props>> = ({ children, name }) => {
    const componentPointerCssVar = `--pointer-events-${name}`;
    React.useEffect(() => {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.documentElement.style.setProperty(componentPointerCssVar, 'none');
    }, [componentPointerCssVar]);

    return (
        <div data-testid={`disable-view-until-mount`} css={componentWrapper}>
            {children}
            <div
                css={loaderWrapper}
                style={{
                    // @ts-ignore // because we want to use a dynamic css variable
                    pointerEvents: `var(${componentPointerCssVar}, auto)`,
                }}
            ></div>
        </div>
    );
};

export default DisableViewUntilMount;

const componentWrapper = css({
    width: '100%',
});

const loaderWrapper = css({
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    cursor: 'wait',
});
